import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// The GA4 base tag (gtag.js load + gtag('config', ...)) lives statically in
// public/index.html <head>, so it fires on every normal page load and is
// detectable by Googlebot. This component only sends a page_view on
// client-side (React Router) navigations — the initial page_view is already
// sent by the config call in index.html, so we skip the first render.
const GA_ID = "G-XPPTNLBEE0";

export function GoogleAnalytics() {
  const { pathname, search } = useLocation();
  const firstLoad = useRef(true);

  useEffect(() => {
    if (firstLoad.current) { firstLoad.current = false; return; }
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: pathname + (search || ""),
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [pathname, search]);

  return null;
}
